export const SERVER_URL = "https://do-calculate.com/api";

export const AgeGregorian_EndPoint = "calculate-age-gregorian";
export const AgeHijri_EndPoint = "calculate-age-hijri";
export const DateGregorianDifferences_EndPoint =
  "calculate-date-gregorian-differences";
export const DateHijriDifferences_EndPoint = "calculate-date-hijri-differences";
export const humanCalculators = [
  {
    name: "حساب العمر",
    link: "/calculator/ar/agegregorian/",
    description:
      " تقوم هذه الحاسبة بحساب العمر بالسنوات والأشهر والأيام باستخدام التقويم الميلادي والهجري",
    showMain: true
  },
  {
    name: "حاسبة العمر بالهجري",
    link: "/calculator/ar/agehijri/",
    description:
      "حساب العمر بالهجري, حاسبة العمر بالهجري, تحويل التاريخ إلى العمر الهجري, حاسبة العمر الهجري, العمر الهجري, تحويل التاريخ إلى سنوات هجرية, حساب العمر بالتاريخ الهجري, حاسبة العمر الاحترافية الهجرية, حساب العمر الدقيق بالهجري, تاريخ الهجرة إلى عمر فعلي, حساب عمر الشخص بالتاريخ الهجري, حساب العمر حسب التقويم الهجري",
    showMain: true
  },
  {
    name: "حاسبة الفرق بين عمرين",
    link: "/calculator/ar/gregoriandifferences/",
    description:
      "تقوم هذه الحاسبة بحساب الفرق بين عمرين معينين باستخدام التقويم الميلادي.",
    showMain: true
  },
  {
    name: "حاسبة الفرق بين تاريخين أو عمرين",
    link: "/calculator/ar/dategregoriandifferences/",
    description:
      "تستخدم هذه الحاسبة لحساب الفرق بين تاريخين معينين باستخدام التقويم الميلادي.",
    showMain: true
  },
  {
    name: "حاسبة الفرق بين تاريخين في الهجري",
    link: "/calculator/ar/datehijridifferences/",
    description:
      "تقوم هذه الحاسبة بحساب الفرق بين تاريخين معينين باستخدام التقويم الهجري.",
  },
  {
    name: "حساب كم باقي على عيد ميلادي",
    link: "/calculator/ar/birthday/",
    description:
      "استخدم هذه الحاسبة لمعرفة الزمن المتبقي على عيد ميلادك بالتفصيل حسب التقويم الميلادي. قم بإدخال تاريخ عيد الميلاد لتحصل على الفارق بين الوقت الحالي وعيد ميلادك بالأشهر والأيام.",
    showMain: true
  },
  {
    name: "تحويل التاريخ من ميلادي الى هجري",
    link: "/calculator/ar/gregorian_to_hijri/",
    description:
      "تحويل التاريخ من ميلادي لهجري عن طريق ادخال التاريخ بالميلادي ومعرفة ما يقابله بالهجري بواسطة محول التاريخ الإلكتروني ",
    showMain: true
  },
  {
    name: "تحويل التاريخ من هجري إلى ميلادي",
    link: "/calculator/ar/hijri_to_gregorian/",
    description:
      "تحويل التاريخ من هجري إلى ميلادي عن طريق إدخال التاريخ بالهجري ومعرفة الموافق له بالتاريخ الميلادي بواسطة محول التاريخ الإلكتروني",
  },
  {
    name: "حساب العمر: بالهجري او بالميلادي",
    link: "/calculator/ar/age/",
    description:
      "برنامج حساب العمر بالهجري وبالميلادي، خدمة حاسبة العمر بالشهور والايام والساعات والدقائق والثواني بالتفصيل بصيغ وأشكال مختلفة بكل دقة وحقائق صحية عن عمرك",
  },
  {
    name: "حاسبة الوقت والزمن",
    link: "/calculator/ar/time-calculator/",
    description:
      "حاسبة الوقت والزمن المجانية تساعدك على إضافة أو طرح قيم الوقت بالأيام، الساعات، الدقائق، أو الثواني بسهولة ويُمكنك أيضًا تعلم المفاهيم المختلفة للزمن.",
    showMain: true
  },
  {
    name: "عدد الايام - حساب عدد الايام",
    link: "/calculator/ar/days-calculator/",
    description:
      "تقوم هذه الحاسبة بحساب الفرق بين تاريخين بوحدات مختلفة مثل الأيام، الأشهر، السنوات، الدقائق، الثواني، الساعات، والأسابيع.",
  },
  {
    name: "حاسبة الأعمار بحسب المواليد",
    link: "/calculator/ar/gregorian/gregorian-year-list/",
    description:
      "تقوم هذه الحاسبة بحساب العمر بالسنوات والأشهر والأيام باستخدام التقويم الميلادي، مع إمكانية إدخال سنة الميلاد فقط.",
  },
  {
    name: " اليوم ميلادي وهجري",
    link: "/calculator/ar/current-date/",
    description:
      "تاريخ اليوم ميلادي وهجري - معرفة التاريخ الحالي، عرض التاريخ الحالي بالتقويم الميلادي والهجري مع تفاصيل اليوم والساعة. معرفة تاريخ اليوم بدقة حسب التقويمين الميلادي والهجري.",
  },
  {
    name: " اليوم ميلادي وهجري",
    link: "/calculator/ar/current-date/",
    description:
      "تاريخ اليوم ميلادي وهجري - معرفة التاريخ الحالي، عرض التاريخ الحالي بالتقويم الميلادي والهجري مع تفاصيل اليوم والساعة. معرفة تاريخ اليوم بدقة حسب التقويمين الميلادي والهجري.",
  }, {
    name: " حاسبة مدة الوفاة",
    link: "/calculator/ar/duration-since-death/",
    description:
      "حاسبة مدة الوفاة - حساب المدة منذ الوفاة بالتقويم الميلادي والهجري. قم بإدخال تاريخ الوفاة لمعرفة المدة التي مرت منذ ذلك التاريخ.",
  },
  {
    name: "حساب ذكرى الزواج السنوية",
    link: "/calculator/ar/wedding-anniversary-calculator/",
    description:
      "حاسبة ذكرى الزواج السنوية - حساب عدد السنوات والأشهر والأيام منذ تاريخ الزواج. قم بإدخال تاريخ زواجك لمعرفة المدة التي مرت منذ ذلك التاريخ.",
  },
];
export default humanCalculators;